
const lengthRegexp = /(?:([\d,.]+)km)?(?:(\d+)m)?/
export function getLengthInMeters(raw: string): number {
    const matches = lengthRegexp.exec(raw) || []
    // Process Kilometers
    // We replace ',' with '.' so parseFloat can interpret it correctly
    const kmStr = matches[1] ? matches[1].replace(',', '.') : '0'
    const kilometers = parseFloat(kmStr) || 0

    const meters = parseInt(matches[2]) || 0
    return kilometers * 1000 + meters
}

const durationRegexp = /(\d+d)?(\d+h)?(\d+m)?(\d+s)?/
export function getDurationInSeconds(raw: string): number {
    const matches = durationRegexp.exec(raw) || []
    const days = parseInt(matches[1]) || 0
    const hours = parseInt(matches[2]) || 0
    const minutes = parseInt(matches[3]) || 0
    const seconds = parseInt(matches[4]) || 0
    return (days * 24 * 3600) + (hours * 3600) + (minutes * 60) + seconds
}

export function formatPace(floatPace: number): string {
    // 1. Sanitize: replace comma with dot and remove non-numeric fluff

    if (isNaN(floatPace)) return "0m0s/km";

    // 2. Separate minutes and seconds
    const minutes = Math.floor(floatPace);
    const fractionalPart = floatPace - minutes;
    const seconds = Math.round(fractionalPart * 60);

    // 3. Format result (using padStart to ensure 2m05s instead of 2m5s)
    const formattedSeconds = seconds.toString().padStart(2, '0');

    return `${minutes}m${formattedSeconds}s /km`;
}